import React from "react";
import ReactSpeedometer from "react-d3-speedometer";
import "./InsightPreview.scss";

const InsightSpeedometer = () => {
    return (
        <div className="speedometer-card">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0">CSAT-V3</h6>
            </div>

            <ReactSpeedometer
                width={250}
                height={180}
                forceRender={true}

                /* Needle */
                needleHeightRatio={0.8}
                needleColor="#504658"
                needleTransition="easeElastic"
                needleTransitionDuration={1500}

                /* Gauge range */
                minValue={0}
                maxValue={100}
                value={0} // ✅ default preview value

                /* Segments */
                customSegmentStops={[0, 30, 70, 100]}
                segmentColors={["#ff4d4f", "#fadb14", "#52c41a"]}
                maxSegmentLabels={1}

                /* Style */
                ringWidth={40}
                textColor="#504658"
                labelFontSize="14"
                valueTextFontSize="16"

                paddingHorizontal={10}
                paddingVertical={10}
            />
        </div>
    );
};

export default InsightSpeedometer;